import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';

const setTruckOnTrip = async (id, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/hireTruck/ontrip-trucks/${id}/setOnTripToTrue`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to set Truck on trip');
  }

  return response.json();
};

const useSetTruckOnTrip = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation((id) => setTruckOnTrip(id, token), {
    onSuccess: () => {
      queryClient.invalidateQueries('startedfreight');
    },
  });
};

export default useSetTruckOnTrip;